// Inventory History export utilities — CSV for unlimited rows

/**
 * Generate and trigger download of an inventory history CSV.
 * CSV format can handle unlimited rows without page limitations.
 *
 * @param {object} data    — Inventory history data including item and history entries
 * @param {string} filename — e.g. "InventoryHistory_ABC_Item_2024-01-01.csv"
 */
export async function downloadInventoryHistoryCsv(data, filename = "inventory-history.csv") {
  if (!data) throw new Error("Inventory history data is required");

  try {
    const { item, history } = data;
    
    // CSV Header
    let csv = "Date,Transaction Type,Quantity,Quantity Before,Quantity After,Reference Type,Reference ID,Reference Number\n";
    
    // CSV Rows
    history.forEach(entry => {
      const referenceText = entry.reference_type === 'invoice' 
        ? `Invoice #${entry.reference_id || ""}` 
        : entry.reference_id || "";
      
      const row = [
        entry.created_at || "",
        entry.transaction_type || "",
        entry.quantity || 0,
        entry.quantity_before || 0,
        entry.quantity_after || 0,
        entry.reference_type || "",
        entry.reference_id || "",
        `"${referenceText.replace(/"/g, '""')}"`
      ];
      csv += row.join(",") + "\n";
    });
    
    // Metadata
    csv += "\n\nItem Details\n";
    csv += `Item Name,"${(item?.item_name || "").replace(/"/g, '""')}"\n`;
    csv += `SKU,"${(item?.sku || "").replace(/"/g, '""')}"\n`;
    csv += `Description,"${(item?.description || "").replace(/"/g, '""')}"\n`;
    csv += `Current Stock,${item?.quantity || 0}\n`;
    csv += `Unit,${item?.unit || ""}\n`;
    csv += `Price,${item?.price || 0}\n`;
    csv += `Low Stock Threshold,${item?.low_stock_threshold || 0}\n`;
    
    // Export Details
    csv += "\n\nExport Details\n";
    csv += `Total Records,${history.length}\n`;
    csv += `Export Date,${new Date().toISOString().split('T')[0]}\n`;
    
    // Create and download
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const a = window.document.createElement("a");
    a.href = url;
    a.download = filename;
    window.document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    window.document.body.removeChild(a);
  } catch (error) {
    console.error("CSV generation error:", error);
    throw error;
  }
}